import { render } from './main';

render(document.getElementById('cads-application'));
